import styled from 'styled-components';

export const BlogWrapper = styled.div`
    display: grid;
    margin: 0 auto;
    max-width: 1080px;
    justify-content: center;
    justify-items: center;
    margin-top: 40px;

    > h1 {
        padding: 50px 50px 15px 50px;
        text-align: center;
        font-size: 36px;
        font-weight: 600;
    }

    > p {
        color: var(--black);
        text-align:center;
        width: 60%;
    }

    section {
        display:flex;
        padding: 50px;

        > div {
            box-shadow: 1.5px 1px 5px rgba(0,0,0,0.3);
            background: var(--white);
            margin: 10px;

            img {
                width:350px;
            }

            .description {
            display:flex;
            padding: 20px;

                div {
                    h1 {
                        color: var(--orange);
                        font-size: 18px;
                        font-weight: 600;
                    }
                    span {
                        font-weight: 600;
                        font-size: 12px;
                    }
                }

                div {
                    h2 {
                        font-size: 20px;
                        padding: 0 0 0 20px;
                        font-weight: 600;
                    }

                    p {
                        padding: 20px 0 0 20px;
                        color: var(--gray);
                        line-height: 25px;
                    }

                    h4 {
                        color: var(--gray);
                        padding: 20px;
                        font-weight: 600;
                    }
                }
            }
        }
    }

    @media (max-width: 1100px) {
        
        section {
            display: block;

            > div {
                display:flex;
                height: 240px;
                img {
                    width: 50%;
                    background-size: cover;
                    background-position: center center;
                }

                .description {
                    div {
                        h4 {
                            padding: 10px 20px 20px 20px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 800px) {

        > h1{
        padding: 0px;

        }
        
        section {
            padding: 40px 0 0 0;
            display: grid;
            margin: 0 auto;

            justify-items: center;
            > div {
                display:block;
                width: 80%;
                height: 500px;
                img {
                    width: 100%;
                    background-size: cover;
                    background-position: center center;
                }

                .description {
                    div {
                        h4 {
                            padding: 10px 20px 20px 20px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 700px) {

        section {
            padding: 40px 0 0 0;
            display: grid;
            margin: 0 auto;
            justify-items: center;

            > div {
                display:block;
                width: 100%;
                height: 550px;
                img {
                    width: 100%;
                    background-size: cover;
                    background-position: center center;
                }

                .description {
                    div {
                        h4 {
                            padding: 10px 20px 20px 20px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 550px) {
        h1{
            font-size: 28px;
        }

        > p {
            color: var(--black);
            text-align:center;
            margin-top: 10px;
            width: 75%;
        }
        section {
            display: grid;
            margin: 0 auto;

            justify-items: center;
            > div {
                display:block;
                width: 100%;
                height: 450px;
                img {
                    width: 100%;
                    height: 200px;
                }

                .description {
                    div {
                        h4 {
                            padding: 10px 20px 20px 20px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 400px) {
        h1{
            font-size: 24px;
        }
        > p {
            color: var(--black);
            text-align:center;
            width: 75%;
            margin-top: 10px;
        }

        section {
            > div {
                width: 100%;
                height: 450px;
                img {
                    width: 100%;
                    height: 200px;
                }

                .description {
                    div {
                        h4 {
                            padding: 10px 20px 20px 20px;
                        }
                    }
                }
            }
        }
    }


    @media (max-width: 360px) {
        section {
            > div {
                width: 100%;
                height: 450px;
            }
        }
    }
`;